const handleDeleteCompanyFailformCampany = {
  title: 'DOCUMENTO NÃO PODE SER DELETADO'
};

export default handleDeleteCompanyFailformCampany;
